const ES = {
  LOADING: 'Cargando ...',
  SAVING: 'Grabando ...',
  SAVE_COMPLETE: 'Grabado completo',
  ZOOM_IN_ERROR: 'El zoom es muy alto.',
  ZOOM_ERROR: 'No es posible aplicar mas zoom.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED: 'No ha sido posible crear un nuevo tópico. Sólo un tópico debe ser seleccionado.',
  ONE_TOPIC_MUST_BE_SELECTED: 'No ha sido posible crear un nuevo tópico. Al menos un tópico debe ser seleccionado.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED_COLLAPSE: 'Tópicos hijos no pueden ser colapsados. Sólo un tópico debe ser seleccionado.',
  SAVE_COULD_NOT_BE_COMPLETED: 'Grabación no pudo ser completada. Intentelo mas tarde.',
  MAIN_TOPIC: 'Tópico Principal',
  SUB_TOPIC: 'Tópico Secundario',
  ISOLATED_TOPIC: 'Tópico Aislado',
  CENTRAL_TOPIC: 'Tópico Central',
  ENTITIES_COULD_NOT_BE_DELETED: 'El tópico o la relación no pudo ser borrada. Debe selecionar al menos una.',
  CLIPBOARD_IS_EMPTY: 'Nada que copiar. Clipboard está vacio.',
  CENTRAL_TOPIC_CAN_NOT_BE_DELETED: 'El tópico central no puede ser borrado.',
  RELATIONSHIP_COULD_NOT_BE_CREATED: 'La relación no pudo ser creada. Una relación padre debe ser seleccionada primero.',
  SESSION_EXPIRED: 'Su session ha expirado. Por favor, ingrese nuevamente.',
  CENTRAL_TOPIC_CONNECTION_STYLE_CAN_NOT_BE_CHANGED: 'El estilo de conexión no se puede cambiar para el tópico central.',
  CENTRAL_TOPIC_STYLE_CAN_NOT_BE_CHANGED: 'Tópico central no se puede cambiar al estilo de línea.',
};

export default ES;
